export default __webpack_public_path__ + "static/media/icon-hamburger.272779af.svg";